import { generator } from '../event-listener.js';
const OnCatch = generator('onCatch');
const OnSuccess = generator('onSuccess');
export { OnCatch, OnSuccess, };
//# sourceMappingURL=promisable.js.map